<script>
import CommonDetail from '@/views/Information/CommonDetail'
import api from '@/utils/api/operation'
export default {
  name: 'NoticeDetail',
  extends: CommonDetail,
  data() {
    return {}
  },
  methods: {
    onload() {
      let params = {
        id: this.rid
      }
      api.getNoticeDetail(params).then(res => {
        let data = res.data
        this.title = data.BT
        this.date = data.FBSJ
        this.content = data.TZNR
        if (data.FJ) {
          this.fileList = data.FJ
        }
      })
    }
  }
}
</script>
